import { Modal, Alert, Button, Stack, Grid } from "@mantine/core";

export function ConfirmationModal({
  opened,
  onClose,
  title,
  message,
  color,
  buttonMessage,
  cancelButtonMessage = "Cancel",
  buttonFunction,
  buttonColor,
  icon,
  disableButtons = false,
}: {
  opened: boolean;
  onClose: () => void;
  title: string;
  message: string;
  buttonMessage: string;
  cancelButtonMessage?: string;
  buttonFunction: () => void;
  buttonColor: string;
  color?: string;
  icon?: React.ReactNode | null;
  disableButtons?: boolean;
}) {
  const handleCloseModal = () => {
    onClose();
  };

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      withCloseButton={false}
      size="md"
      trapFocus
      returnFocus
      closeOnEscape
      styles={{
        root: {
          background: "none",
          boxShadow: "none",
          padding: 0,
          height: "auto",
        },
        header: {
          padding: 0,
        },
        body: {
          padding: 0,
        },
        close: {
          display: "none",
        },
        overlay: {
          backgroundColor: "rgba(0, 0, 0, 0.7)",
        },
      }}
    >
      <Alert
        title={title}
        icon={icon || null}
        variant="filled"
        color="#1a1a1a"
      >
        <Stack>
          {message}
          <Grid gutter="lg" p="xs">
            <Button
              onClick={buttonFunction}
              color={buttonColor}
              style={{ alignSelf: "flex-start", marginRight: "10px", borderRadius: "8px" }}
              disabled={disableButtons}
              data-autofocus
            >
              {buttonMessage}
            </Button>
            <Button
              onClick={handleCloseModal}
              color="gray"
              variant="outline"
              style={{ alignSelf: "flex-start", borderRadius: "8px" }}
              disabled={disableButtons}
            >
              {cancelButtonMessage}
            </Button>
          </Grid>
        </Stack>
      </Alert>
    </Modal>
  );
}
